// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Package_packageSelection__0dhor {
  margin-bottom: 16px;
}
.Package_packageSelection__0dhor.Package_packageDescription__lqO0v {
  margin-bottom: 0;
}
.Package_packageSelection__0dhor .Package_label__RHf6H {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.Package_packageSelection__0dhor .Package_packageDescription__lqO0v {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  margin: 0;
  flex: 1 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_packageAddonsItem__gn40p {
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_packageAddonsItemNamemain__YpJnt .Package_packageAddonsItemName__kE6Vk {
  color: #313131;
  font: var(--body-font-three);
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_packageAddonsItemNamemain__YpJnt .Package_packageAddonsItemPrice__YikMK {
  color: #313131;
  font: var(--body-font-three);
  font-weight: 600;
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_packageAddonsItemRequired__sT7uZ {
  background-color: #f44336;
  color: #ffffff;
  padding: 1px 7px;
  border-radius: 500px;
  font: var(--body-font-four);
  white-space: nowrap;
  flex-shrink: 0;
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_quantityDiv__Tw\\+-T {
  display: flex;
  align-items: center;
  border: 1px solid #dfe4eb;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 5px;
}
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_quantityDiv__Tw\\+-T input::-webkit-outer-spin-button,
.Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_quantityDiv__Tw\\+-T input::-webkit-inner-spin-button {
  display: none;
  margin: 0;
  -moz-appearance: textfield;
}
@media (max-width: 425px) {
  .Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_quantityDiv__Tw\\+-T {
    display: block;
  }
  .Package_packageSelection__0dhor .Package_packageAddonsList__hIkvd .Package_quantityDiv__Tw\\+-T button {
    width: 100%;
    margin-bottom: 5px;
  }
}

.Package_totalPriceWrp__UeQA0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e1d4cf;
  padding: 12px;
  border-radius: 8px;
}
.Package_totalPriceWrp__UeQA0 .Package_totalPriceWrpText__FXkoD {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.Package_totalPriceWrp__UeQA0 .Package_totalPriceWrpValue__cSFZH {
  font: var(--body-font-two);
  color: var(--primary-Text);
  font-weight: 600;
  margin: 0 5px;
}

.Package_showDetails__gWOov {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.Package_dropDownAddOn__\\+YmfK {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/pages/vendors-list/Modals/Package.module.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;AACD;AACC;EACC,gBAAA;AACF;AAEC;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAAF;AAGC;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;AAIE;EAEC,mBAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJH;AAQG;EACC,cAAA;EACA,4BAAA;AANJ;AASG;EACC,cAAA;EACA,4BAAA;EACA,gBAAA;AAPJ;AAWE;EACC,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AATH;AAWE;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AATH;AAUG;;EAEC,aAAA;EACA,SAAA;EACA,0BAAA;AARJ;AAUG;EAbD;IAcE,cAAA;EAPF;EAQE;IACC,WAAA;IACA,kBAAA;EANH;AACF;;AAYA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AATD;AAWC;EACC,4BAAA;EACA,0BAAA;AATF;AAYC;EACC,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;AAVF;;AAcA;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAXD;;AAcA;EACC,4BAAA;EACA,4BAAA;EACA,gBAAA;AAXD","sourcesContent":[".packageSelection {\r\n\tmargin-bottom: 16px;\r\n\r\n\t&.packageDescription {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\r\n\t.label {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tdisplay: block;\r\n\t\tmargin-bottom: 4px;\r\n\t}\r\n\r\n\t.packageDescription {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 400;\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tmargin: 0;\r\n\t\tflex: 1;\r\n\t\tdisplay: -webkit-box;\r\n\t\t-webkit-box-orient: vertical;\r\n\t\toverflow: hidden;\r\n\t\ttext-overflow: ellipsis;\r\n\t\tline-height: 1.4;\r\n\t}\r\n\r\n\t.packageAddonsList {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 8px;\r\n\r\n\t\t.packageAddonsItem {\r\n\t\t\t// border: 1px solid #DFE4EB;\r\n\t\t\tborder-radius: 12px;\r\n\t\t\tpadding: 8px;\r\n\t\t\t// background-color: #FFFFFF;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\tgap: 12px;\r\n\t\t}\r\n\r\n\t\t.packageAddonsItemNamemain {\r\n\t\t\t.packageAddonsItemName {\r\n\t\t\t\tcolor: #313131;\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t}\r\n\r\n\t\t\t.packageAddonsItemPrice {\r\n\t\t\t\tcolor: #313131;\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.packageAddonsItemRequired {\r\n\t\t\tbackground-color: #f44336;\r\n\t\t\tcolor: #ffffff;\r\n\t\t\tpadding: 1px 7px;\r\n\t\t\tborder-radius: 500px;\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\twhite-space: nowrap;\r\n\t\t\tflex-shrink: 0;\r\n\t\t}\r\n\t\t.quantityDiv {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tborder: 1px solid #dfe4eb;\r\n\t\t\tborder-radius: 8px;\r\n\t\t\toverflow: hidden;\r\n\t\t\tmargin-top: 5px;\r\n\t\t\tinput::-webkit-outer-spin-button,\r\n\t\t\tinput::-webkit-inner-spin-button {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t\tmargin: 0;\r\n\t\t\t\t-moz-appearance: textfield;\r\n\t\t\t}\r\n\t\t\t@media (max-width: 425px) {\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tbutton {\r\n\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\tmargin-bottom: 5px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.totalPriceWrp {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tbackground-color: #e1d4cf;\r\n\tpadding: 12px;\r\n\tborder-radius: 8px;\r\n\r\n\t.totalPriceWrpText {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t.totalPriceWrpValue {\r\n\t\tfont: var(--body-font-two);\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-weight: 600;\r\n\t\tmargin: 0 5px;\r\n\t}\r\n}\r\n\r\n.showDetails {\r\n\tcursor: pointer;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n}\r\n\r\n.dropDownAddOn {\r\n\tfont: var(--body-font-three);\r\n\tcolor: var(--secondary-Text);\r\n\tfont-weight: 400;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"packageSelection": `Package_packageSelection__0dhor`,
	"packageDescription": `Package_packageDescription__lqO0v`,
	"label": `Package_label__RHf6H`,
	"packageAddonsList": `Package_packageAddonsList__hIkvd`,
	"packageAddonsItem": `Package_packageAddonsItem__gn40p`,
	"packageAddonsItemNamemain": `Package_packageAddonsItemNamemain__YpJnt`,
	"packageAddonsItemName": `Package_packageAddonsItemName__kE6Vk`,
	"packageAddonsItemPrice": `Package_packageAddonsItemPrice__YikMK`,
	"packageAddonsItemRequired": `Package_packageAddonsItemRequired__sT7uZ`,
	"quantityDiv": `Package_quantityDiv__Tw+-T`,
	"totalPriceWrp": `Package_totalPriceWrp__UeQA0`,
	"totalPriceWrpText": `Package_totalPriceWrpText__FXkoD`,
	"totalPriceWrpValue": `Package_totalPriceWrpValue__cSFZH`,
	"showDetails": `Package_showDetails__gWOov`,
	"dropDownAddOn": `Package_dropDownAddOn__+YmfK`
};
export default ___CSS_LOADER_EXPORT___;
